import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enDashboard from '../locales/en/dashboard.json';
import enNavigation from '../locales/en/navigation.json';
import enProfile from '../locales/en/profile.json';
import enContent from '../locales/en/content.json';
import enBilling from '../locales/en/billing.json';
import enNotifications from '../locales/en/notifications.json';
import enAdmin from '../locales/en/admin.json';

import frCommon from '../locales/fr/common.json';
import frAuth from '../locales/fr/auth.json';
import frDashboard from '../locales/fr/dashboard.json';
import frNavigation from '../locales/fr/navigation.json';
import frProfile from '../locales/fr/profile.json';
import frContent from '../locales/fr/content.json';
import frBilling from '../locales/fr/billing.json';
import frNotifications from '../locales/fr/notifications.json';
import frAdmin from '../locales/fr/admin.json';

import esCommon from '../locales/es/common.json';
import esAuth from '../locales/es/auth.json';
import esDashboard from '../locales/es/dashboard.json';
import esNavigation from '../locales/es/navigation.json';
import esProfile from '../locales/es/profile.json';
import esContent from '../locales/es/content.json';
import esBilling from '../locales/es/billing.json';
import esNotifications from '../locales/es/notifications.json';
import esAdmin from '../locales/es/admin.json';

// Define resources
const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    navigation: enNavigation,
    profile: enProfile,
    content: enContent,
    billing: enBilling,
    notifications: enNotifications,
    admin: enAdmin,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    dashboard: frDashboard,
    navigation: frNavigation,
    profile: frProfile,
    content: frContent,
    billing: frBilling,
    notifications: frNotifications,
    admin: frAdmin,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    dashboard: esDashboard,
    navigation: esNavigation,
    profile: esProfile,
    content: esContent,
    billing: esBilling,
    notifications: esNotifications,
    admin: esAdmin,
  },
};

// Supported languages with flag codes (ISO 3166-1 alpha-2 country codes for flag display)
export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English', flagCode: 'GB' },
  { code: 'fr', name: 'French', nativeName: 'Français', flagCode: 'FR' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flagCode: 'ES' },
] as const;

export type SupportedLanguage = typeof supportedLanguages[number]['code'];

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'navigation', 'profile', 'content', 'billing', 'notifications', 'admin'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'preferred_language',
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false, // Disable suspense for immediate re-renders
    },
  });

export default i18n;

